import React, { useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import FormBox from "../../component/FormBox/FormBox";
import StepBar from "../../component/StepBar/StepBar";
import {
    Box,
    Button,
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    InputLabel,
    makeStyles,
    MenuItem,
    Paper,
    Radio,
    RadioGroup,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
} from "@material-ui/core";
import errorWarning from "../../images/icon_warning.gif";
import { isEmpty, isNotEmpty } from "../../Utils";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentStep, setFieldValues } from "../../redux/action";
import { getFieldValues, getFormId } from "../../redux/selector";
import ErrorMsg from "../../component/ErrorMsg/ErrorMsg";
import FileInput from "../../component/FileInput/FileInput";
import MultiColumnTableConfirm from "../../component/MultiColumnTable/MultiColumnTableConfirm";

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
});

export default function Confirmation() {
    const formId = "Form050";
    const stepName = "Confirmation";

    const { t, i18n } = useTranslation();
    const classes = useStyles();

    const testHeaders = [
        {
            name: "field1",
            type: "string",
        },
        {
            name: "field2",
            type: "string",
        },
        {
            name: "field3",
            type: "number",
        },
        {
            name: "field4",
            type: "number",
        },
        {
            name: "field5",
            type: "number",
        },
        {
            name: "field6",
            type: "number",
        },
        {
            name: "field7",
            type: "number",
        },
        {
            name: "field8",
            type: "number",
        },
        {
            name: "field9",
            type: "number",
        },
    ];

    const fieldValues = useSelector(getFieldValues());
    const { Application } = fieldValues;
    const dispatch = useDispatch();

    const multiTableRecord = Application.multiTable;

    const onPrev = () => {
        dispatch(setCurrentStep("MultiColumnSample"));
    };

    return (
        <Box>
            <FormBox header={"Sample Multiple Column Table"}>
                <MultiColumnTableConfirm
                    label="simple table"
                    numOfColumnPerPage={4}
                    headers={testHeaders}
                    formId={formId}
                    records={multiTableRecord}
                />
            </FormBox>
            <StepBar disableSave finalSubmitStep onBack={onPrev} />
        </Box>
    );
}
